<div class="flex-wrap criterio-row" *ngIf="meta">
    <div class="inline-flex criterio">
        <label style="opacity:.6">
            <small><strong>Criterio</strong></small>
        </label>
        <p>{{meta.criterios.nombre}}</p>
        <p style="opacity:.6;">
            <small>{{meta.codigo}}-{{meta.id}}</small>
        </p>
    </div>
    <div class="inline-flex" style="flex-grow: 5;">
        <div class="flex-wrap">
            <ng-container *ngFor="let criterioHijo of meta.criterios.niveles.criterios">
                <div [ngClass]="{'logro_seleccion': criterioHijo['isSeleccionado']}"
                     class="logro_evaluado">
                    <label style="opacity:.6">
                        <small><strong>{{criterioHijo.escala.nombre}}</strong></small>
                    </label>
                    <ng-container> <!--<*ngIf="showExtendedInfo">-->
                        <div>
                            <p *ngIf="criterioHijo.escala.nickName !== 'P'; else pendiente">
                                {{criterioHijo.nombre}}</p>
                            <ng-template #pendiente>
                                <p>Pendiente</p>
                            </ng-template>
                        </div>
                    </ng-container>
                    <!--<small>-->
                    <!--<pre>{{criterioHijo | json}}</pre>-->
                    <!--</small>-->
                </div>
            </ng-container>
        </div>
        <div class="flex-wrap">
            <span class="spacer"></span>
            <button mat-raised-button color="primary" (click)="cerrar()">Cerrar</button>
        </div>
    </div>
</div>